import {Component, input} from '@angular/core';
import {AutoplayOnViewDirective} from "../../directives/autoplay-on-view.directive";

@Component({
  selector: 'app-loading-card',
    imports: [
        AutoplayOnViewDirective
    ],
  templateUrl: './loading-card.component.html',
  styleUrl: './loading-card.component.scss'
})
export class LoadingCardComponent {
  title = input<string>()
}
